import React from 'react'
import LeftmenuIn from '../Components/LeftmenuIn'
import DashnavIn from '../Components/DashnavIn'
import EditSchemeComp from './EditSchemeComp'

function EditScheme() {
  return (
    <div className='mainContainer'>
      <LeftmenuIn />
      <div className='theMainContainer'>
        <DashnavIn />
        <EditSchemeComp />
      </div>
    </div>
  )
}

export default EditScheme

